<div class="row">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-sm">
  <thead>
    <tr>
      <th scope="col">Nº Empenho</th>
      <th scope="col">Emissão Empenho</th>
      <th scope="col">Data da liquidação</th>
      <th scope="col">Valor da liquidação</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of execucao?.LiquidacaoDocSimilarSim">
      <td>
        <span>{{item.NotaEmpenhoNumero}}</span>
      </td>

      <td>
        <span>{{item.NotaEmpenhoDataEmissao}}</span>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.LiquidacaoEmpenhoDt}}</span>
        <select *ngIf="item.editavel" [compareWith]="compareFn" class="form-control"
          [(ngModel)]="itemAtual.liquidacaoId" [ngModelOptions]="{standalone: true}" (change)="atribuirLiquidacao()">
          <option *ngFor="let item of empenho.liquidacoes" [ngValue]="item.id">
            {{+item.parcela > 0 ? item.parcela + 'ª: ' : ''}} {{item.documento}} - {{item.data_liquidacao |
            date:'dd/MM/yyyy':'GMT'}} - {{item.valor_liquidado | number : '1.2-2'}}
          </option>
        </select>
      </td>

      <td>
        <span>{{item.LiquidacaoEmpenhoValor}}</span>
      </td>

      <td class="text-right">
        <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>